var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78754 7.49996C3.32785 8.46661 4.23031 9.75285 5.39095 10.8419C6.73264 12.1009 8.31331 13 10.0002 13C11.687 13 13.2677 12.1009 14.6094 10.8419C15.77 9.75285 16.6725 8.46661 17.2128 7.49996C16.6725 6.5333 15.77 5.24707 14.6094 4.15801C13.2677 2.89905 11.687 1.99996 10.0002 1.99996C8.31331 1.99996 6.73264 2.89905 5.39095 4.15801C4.23031 5.24707 3.32785 6.5333 2.78754 7.49996ZM4.13646 2.82108C5.64408 1.40643 7.65368 0.166626 10.0002 0.166626C12.3466 0.166626 14.3562 1.40643 15.8639 2.82108C17.3792 4.243 18.4946 5.93919 19.0701 7.09001C19.1991 7.34808 19.1991 7.65184 19.0701 7.90991C18.4946 9.06073 17.3792 10.7569 15.8639 12.1788C14.3562 13.5935 12.3466 14.8333 10.0002 14.8333C7.65368 14.8333 5.64408 13.5935 4.13646 12.1788C2.6211 10.7569 1.50568 9.06073 0.930271 7.90991C0.801238 7.65184 0.801238 7.34808 0.930271 7.09001C1.50568 5.93919 2.6211 4.243 4.13646 2.82108Z",
    fill: "#19191B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 5.66663C8.98764 5.66663 8.16683 6.48744 8.16683 7.49996C8.16683 8.51248 8.98764 9.33329 10.0002 9.33329C11.0127 9.33329 11.8335 8.51248 11.8335 7.49996C11.8335 6.48744 11.0127 5.66663 10.0002 5.66663ZM6.3335 7.49996C6.3335 5.47492 7.97512 3.83329 10.0002 3.83329C12.0252 3.83329 13.6668 5.47492 13.6668 7.49996C13.6668 9.525 12.0252 11.1666 10.0002 11.1666C7.97512 11.1666 6.3335 9.525 6.3335 7.49996Z",
    fill: "#19191B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0e2a1af85766f74ebb712962669df404.svg";
export { ForwardRef as ReactComponent };